import React, { useEffect, useRef } from 'react';
import Modal from 'react-modal';
import './ReactModal.scss';

// for use with 'react-modal' Modal components
export const useReactModal = function useReactModal(options = {}) {
    const { modalProps = {}, appElementSelector = '#root' } = options;

    const [isOpen, setModalIsOpen] = React.useState(false);

    const setAppElementRef = useRef(false);

    useEffect(() => {
        if (!setAppElementRef.current) {
            const appElement = document.querySelector(appElementSelector);
            if (!appElement) {
                console.warn(
                    `Did not find an element with selector: ${appElementSelector}, 
                    the useReactModal hook will not function correctly`
                );
            } else {
                Modal.setAppElement(appElement);
            }
            setAppElementRef.current = true;
        }
    }, [appElementSelector]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [isOpen]);

    const close = () => setModalIsOpen(false);

    return {
        isOpen,
        close,
        open: () => setModalIsOpen(true),
        toggle: () => setModalIsOpen(prev => !prev),
        modalProps: {
            className: 'reactModalContent',
            overlayClassName: 'reactModalOverlay',
            shouldCloseOnOverlayClick: false,
            onRequestClose: close,
            isOpen,
            ...modalProps
        }
    };
};

export default useReactModal;
